import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Table, Typography, Button, Spin, message } from "antd";
import { BASE_URL } from "../Components/Constant";
import ApiService from "../Components/apiService";
import AddConnectionModal from "./AddSystemConnectionModal";

const { Title } = Typography;

const ConnectorDetail = () => {
  const { id } = useParams();
  const [connector, setConnector] = useState(null);
  const [actions, setActions] = useState([]);
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  // Fetch connector + connections (from backend)
  const fetchConnectorDetails = async () => {
    setLoading(true);
    try {
      // Connector details
      const connectorService = new ApiService(
        `${BASE_URL}/connectors/${id}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const connectorRes = await connectorService.makeCall();
      setConnector(connectorRes);

      // Dummy actions (replace with backend later)
      const dummyActions = [
        { id: "a1", name: "Create Lead", apiName: "createLead", description: "Add a new lead" },
        { id: "a2", name: "Update Opportunity", apiName: "updateOpportunity", description: "Update an opportunity record" },
        { id: "a3", name: "Delete Contact", apiName: "deleteContact", description: "Remove a contact from CRM" }
      ];
      setActions(dummyActions);

      // Connections list
      const connectionsService = new ApiService(
        `${BASE_URL}/connector_configs/get_by_connector_id?connector_id=${id}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      
      const connectionsRes = await connectionsService.makeCall();

      console.log('Fetched connections:', connectionsRes);

      const normalizedConnections = (connectionsRes || []).map((c) => ({
        id: c._id?.$oid || c._id,
        name: c.name || c.base_url || "Unnamed Connection",
        connectorId: c.connector_id || "",
        authType: c.auth_type || "",
        baseUrl: c.base_url || "",
        // createdAt: c.created_at
        //   ? new Date(c.created_at).toLocaleDateString()
        //   : "",
        // updatedAt: c.updated_at
        //   ? new Date(c.updated_at).toLocaleDateString()
        //   : "",
      }));
      console.log('Normalized connections:', normalizedConnections);
      setConnections(normalizedConnections);
      
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch connector details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConnectorDetails();
  }, [id]);

  const actionsColumns = [
    { title: "Action Name", dataIndex: "name", key: "name" },
    { title: "API Name", dataIndex: "apiName", key: "apiName" },
    { title: "Description", dataIndex: "description", key: "description" },
  ];

  const connectionsColumns = [
  { title: "Connection Name", dataIndex: "name", key: "name" },
  { title: "Connector ID", dataIndex: "connectorId", key: "connectorId" },
  { title: "Auth Type", dataIndex: "authType", key: "authType" },
  { title: "Base URL", dataIndex: "baseUrl", key: "baseUrl" },
  // { title: "Created At", dataIndex: "createdAt", key: "createdAt" },
  // { title: "Updated At", dataIndex: "updatedAt", key: "updatedAt" },
];


  return (
    <div style={{ padding: 20 }}>
      <Card bordered style={{ borderRadius: 8 }}>
        <Spin spinning={loading}>
          {connector && (
            <>
              <Title level={3}>{connector.name}</Title>
              <p>{connector.description}</p>

              {/* Actions */}
              <Card title="Available Actions" style={{ marginTop: 20 }}>
                <Table
                  rowKey="id"
                  dataSource={actions}
                  columns={actionsColumns}
                  bordered
                  pagination={false}
                />
              </Card>

              {/* Connections */}
              <Card
                title="Connections"
                style={{ marginTop: 20 }}
                extra={
                  <Button type="primary" onClick={() => setModalVisible(true)}>
                    Add New Connection
                  </Button>
                }
              >
                <Table
                  rowKey="id"
                  dataSource={connections}
                  columns={connectionsColumns}
                  bordered
                  pagination={false}
                />
              </Card>

              <AddConnectionModal
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                connectorId={id}
                onSuccess={fetchConnectorDetails} // reload after adding
              />
            </>
          )}
        </Spin>
      </Card>
    </div>
  );
};

export default ConnectorDetail;
